'use strict';



const $ = require('jquery');
const vex = require('./dialogue');



/**
 * Confirm Form Submit
 *
 * A simple pattern for requiring a confirmation prior to form submission, but
 * using a custom confirmation renderer.
 */
module.exports = function confirmFormSubmit($form, getMessage = Function(), onConfirm = Function(), confirmed) {

	if(confirmed) {
		onConfirm();
		$form.trigger({
			type: 'submit',
			notDuplicate: true
		});
		$('.vex').fadeOut(); // FireFox suffers from a CSS transition glitch that causes Vex to flicker on close. This is an easy fix.
		return;
	}

	$form.one('submit', function(e) {

		const $form = $(this);
		e.preventDefault();
		vex.dialog.confirm({
			unsafeMessage: getMessage($form),
			callback(res) {
				confirmFormSubmit($form, getMessage, onConfirm, res);
			}
		});

	});

};